import React from 'react'
import SavingImg1 from '../../Images/SavingImg/OptionalSaving.jpg'
import SideNav from '../Navigation/SideNav'
import Aos from 'aos'

const AaishikSaving = () => {

    Aos.init({
        duration: 1500,
        once: false,
        mirror: false,
        easing: 'ease-in-out-sine'
    })

    return (
        <>

            <div className='main'>
                <div className='left-fixed'></div>
                <div className='d-body'>
                    <div className='d-body-nav' data-aos='fade-right'>
                        <SideNav />
                    </div>
                    <div className='d-body-main' data-aos='fade-right'>
                        <div className='saving-body-top'>
                            <h2>ऐच्छिक बचत</h2>
                        </div>
                        <div className='saving-body'>
                            <div className='saving-main'>
                                <h3>विशेषताहरू :</h3>
                                <p>
                                    <ul>
                                        <li>कार्यलय समयमा जुनसुकै बेलापनि रकम राख्न र झिक्न मिल्ने ।</li>
                                        <li>ऐच्छिक रूपमा बचत गर्न सक्ने ।</li>
                                        <li>विद्युतिय प्रणालीबाट कारोबार गर्न मिल्ने ।</li>
                                        <li>भुक्तानी पुर्जाको व्यवस्था गरीने ।</li>
                                        <li>सदस्य रहुञ्जेल खाता सुचारु हुने ।</li>
                                        <li>सदस्य रहुञ्जेल खाता बन्द गर्न नमिल्ने ।</li>
                                        <li>ब्याजलाई संरक्षित पूँजी फिर्ता कोष वितरणमा गणना गरिने ।</li>
                                        <li>उत्कृष्ट बचत कर्तालाई पुरस्कार तथा सम्मान प्रदान गरिने ।</li>
                                        <li>खातामा न्युनतम मौज्दात रु ५००।– राखि बाँकी फिर्ता लान सकिनेछ ।</li>
                                    </ul>
                                </p>
                            </div>
                            <div className='savingimg'>
                                <img src={SavingImg1} alt='saving-1' />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='right-fixed'></div>
            </div>
        </>
    )
}

export default AaishikSaving